import React from "react"
import Secone from "../components/Secone";
import Sponsors from "../components/Sponsors";
import ProductsSlider from "../components/ProductsSlider";
import Aboutus from "../components/Aboutus";


const Homep = () => {
    return(
        <div>
            <Secone />
            <Aboutus />
            <ProductsSlider />
            <Sponsors />
            {/* <Carouselnew /> */}
            {/* <Sectwo />
            <Secthree />
            <Secfour />
            <Secfive />
            <Secsix /> */}
        </div>
    )
}

export default Homep; 